import { ChangeDetectionStrategy, Component, Input, OnInit, SecurityContext } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizeBypassPipe } from 'src/app/angie-shared/pipes/sanitize-bypass/sanitize-bypass.pipe';
import { DocumentRefService } from 'src/app/core';
import { IAuthForm, IAuthLayoutConfig } from '../../models/auth.model';

@Component({
	selector: 'angie-auth-wrapper',
	templateUrl: './auth-wrapper.component.html',
	styleUrls: ['./auth-wrapper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthWrapperComponent implements OnInit {
	@Input() layoutConfig: IAuthLayoutConfig;
	@Input() title: string;
	@Input() form: IAuthForm;
	safeHtml: SafeHtml;
	constructor(
		private sanitizer: SanitizeBypassPipe,
		private documentRef: DocumentRefService
	) {}

	ngOnInit(): void {
		this.documentRef.addBodyClass('bg--white');
		this.safeHtml = this.sanitizer.transform(this.layoutConfig.login_welcome_message, SecurityContext.HTML);
	}
}
